import { Script } from "gatsby";

const gorgiasScriptOne = () => ({
  __html: `
  var script = document.createElement('script');
  script.src = 'https://config.gorgias.chat/bundle-loader/01KGQ7314X2FKKJ89ZTDB8ARH3';
  window.document.body.appendChild(script);
  `,
});

const gorgiasScriptTwo = () => ({
  __html: `
  var script = document.createElement('script');
  script.src = 'https://static.9gtb.com/loader.js?g_cvt_id=f4abca44-26ae-429b-8b2e-6a377b28eb61';
  window.document.body.appendChild(script);
  `,
});

export function wrapPageElement({ element }) {
  return (
    <>
      {element}
      <Script id="gorgias-chat-widget-install-v3" dangerouslySetInnerHTML={gorgiasScriptOne()} strategy="idle" />
      <Script id="gorgias-id-bundle" dangerouslySetInnerHTML={gorgiasScriptTwo()} strategy="idle" />
    </>
  );
}
